import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import Entcon from "./entcon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Ent() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Entcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best ENT Specialists in Whitefield</title>
        <meta
          name="description"
          content="We have the best ENT Specialists in Whitefield. If you are looking for this then feel free to contact us or call us today."
        />
        <meta
          name="keywords"
          content="Best ENT Specialists in Whitefield, Best ENT Specialists in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/bestentinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestentinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert ENT (Ear, Nose & Throat) services including diagnosis and treatment of sinusitis, ear infections, hearing issues, tonsillitis, allergy care, balance disorders, and minor ENT procedures by experienced specialists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "ENT consultation and diagnosis",
              "Sinus and allergy care",
              "Ear infection and hearing issues treatment",
              "Tonsillitis and throat care",
              "Balance disorder assessment",
              "Snoring and sleep breathing evaluation",
              "Minor ENT procedures and follow-ups",
            ],
            keywords: [
              "best ent in Immadihalli",
              "best ent in Whitefield",
              "best ent in Bangalore",
              "best ent in Kundalahalli",
              "best ent in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best ENT Specialists in Whitefield sets us apart as a leader in ENT
        services. Contact us today for the best ENT specialist in Whitefield
      </h2>
      <Servicebanner name="ENT" banner={"../photo/dd8.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Ent;
